import type { DisplayItem } from '../shared.js';
/** Keep originals and QR graphics untouched; only local JPEG photos get a screen-sized variant. */
export function displayImageUrl(url: string): string {
  const match = url.match(/^\/media\/([a-zA-Z0-9_-]+\.jpe?g)$/i);
  return match ? `/media/display/v1/${match[1]}` : url;
}
export function playlistImageUrls(items: DisplayItem[]): string[] {
  return [...new Set(items.flatMap(({ media }) => {
    if (media.type === 'image') return [displayImageUrl(media.url)];
    if (media.type === 'template' && media.template) return [displayImageUrl(media.template.imageUrl), media.template.qrImageUrl];
    return [];
  }).filter((url) => url && !url.startsWith('data:')))];
}
